<ng-container>
  <tj-map [lng]="lng" [lat]="lat" [mapHeight]="mapHeight"></tj-map>
</ng-container>
